'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesScorecardRow.css');

var TargetDateSeriesScorecardRow = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesScorecardRow, _Component);

  function TargetDateSeriesScorecardRow(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesScorecardRow);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesScorecardRow.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesScorecardRow)).call(this, props));

    var iyvCode = props.iyvCode,
        targetDateSeries = props.targetDateSeries;


    var query = {
      fff: 'fossil',
      dff: 'deforestation',
      gef: 'gender-equality',
      gff: 'guns',
      pff: 'prison-industrial-complex',
      wff: 'military-weapons',
      tff: 'tobacco'
    }[iyvCode] || null;

    var label = {
      fff: 'Fossil fuel',
      dff: 'Deforestation',
      gef: 'Gender equality',
      gff: 'Civilian firearms',
      pff: 'Prison industrial complex',
      wff: 'Military weapons',
      tff: 'Tobacco'
    }[iyvCode] || null;

    var gradeField = {
      fff: 'grade_fossil',
      dff: 'grade_deforestation',
      gef: 'grade_gender_equality',
      gff: 'grade_guns',
      pff: 'grade_prison_industrial_complex',
      wff: 'grade_military',
      tff: 'grade_tobacco'
    }[iyvCode] || null;

    _this.state = {
      iyvCode: iyvCode,
      targetDateSeries: targetDateSeries,
      query: query,
      label: label,
      gradeAsInt: targetDateSeries[gradeField] || null
    };
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeriesScorecardRow, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          iyvCode = _state.iyvCode,
          targetDateSeries = _state.targetDateSeries,
          query = _state.query,
          label = _state.label,
          gradeAsInt = _state.gradeAsInt;


      var icon = {
        fff: require('../../../static/images/icons/fff-icon.svg'),
        dff: require('../../../static/images/icons/dff-icon.svg'),
        gef: require('../../../static/images/icons/gef-icon.svg'),
        gff: require('../../../static/images/icons/gff-icon.svg'),
        pff: require('../../../static/images/icons/pff-icon.svg'),
        wff: require('../../../static/images/icons/wff-icon.svg'),
        tff: require('../../../static/images/icons/tff-icon.svg')
      }[iyvCode] || null;

      if (!query || !label || !icon || !gradeAsInt) {
        return null;
      }

      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.routes.targetDateFunds + '/' + targetDateSeries.strategy_name_query + '?issue=' + query,
            title: targetDateSeries.strategy_name
          },
          _react2.default.createElement(
            'div',
            { styleName: 'scorecard-header-grade-flex' },
            _react2.default.createElement(
              'div',
              { styleName: 'icon-label-flex' },
              _react2.default.createElement(
                'div',
                { styleName: 'result-lbl-icon-bbl' },
                _react2.default.createElement('img', {
                  styleName: 'result-lbl-icon',
                  src: icon,
                  alt: label + 'grade'
                })
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'scorecard-header-grade-label' },
                label,
                ' grade'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'scorecard-header-grade grade-' + gradeAsInt },
              _react2.default.createElement(_components.Grade, { grade: gradeAsInt, square: true })
            )
          )
        )
      );
    }
  }]);
  return TargetDateSeriesScorecardRow;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesScorecardRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesScorecardRow/TargetDateSeriesScorecardRow.js
// module id = 1455
// module chunks = 0